module.exports = __webpack_public_path__ + "static/media/be.a74cdcaa.png";